import { useMemo } from 'react';
import { useGqlQuery } from '@API/useAvQuery';
import { DescriptorType } from '@fabric-ui/components';
import { QueryKey } from '@fabric-ui/utils';
import { GET_MEASUREMENTS_AND_CALCULATED_DIMENSIONS } from './gql';

export const useMetrics = (options?) => {
  const queryResult = useGqlQuery<{
    findMeasurementsByAccountId: { measurement; createdByUserId; updatedByUserId; id }[];
    findCalculatedDimensionsByAccountId: { calculatedDimension; createdByUserId; updatedByUserId; id }[];
  }>({
    queryKey: [QueryKey.MeasurementsAndCalculatedDimensions],
    query: GET_MEASUREMENTS_AND_CALCULATED_DIMENSIONS,
    select: (_, data) => data,
    ...options,
  });

  const data = useMemo(() => {
    if (!queryResult.data) {
      return { all: [], visible: [], asObject: {} };
    }

    const measurementsData = queryResult.data.findMeasurementsByAccountId || [];

    const measurementsAll = measurementsData.map(v => {
      const { measurement, ...rest } = v;
      return {
        ...measurement,
        ...rest,
        createdByUserId: v.createdByUserId,
        updatedByUserId: v.updatedByUserId,
        isRecommended: true,
        type: DescriptorType.TYPE_DOUBLE,
        id: v.id,
      };
    });

    return {
      all: measurementsAll,
      visible: measurementsAll.filter(({ hidden }) => !hidden),
      asObject: measurementsAll.reduce((acc, item) => {
        const { systemName, ...rest } = item;
        acc[systemName] = rest;
        return acc;
      }, {}),
    };
  }, [queryResult.data]);

  return { ...queryResult, data };
};
